import { render, staticRenderFns } from "./FilterBadges.vue?vue&type=template&id=7f565520&scoped=true&"
import script from "./FilterBadges.vue?vue&type=script&lang=js&"
export * from "./FilterBadges.vue?vue&type=script&lang=js&"
import style0 from "./FilterBadges.vue?vue&type=style&index=0&id=7f565520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f565520",
  null
  
)

export default component.exports